module.exports = __webpack_public_path__ + "static/img/golds.0c44c9f1.png";